export default (number = 0) => {
  const thousand = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' })
  return thousand.format(number)
}
